export function operacaoPostoControleSiadInRequest(params = {}) {
  return {
    type: '@operacaopostocontrolesiad/POSTOCONTROLESIAD_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoPostoControleSiad(poco_codigo) {
  return {
    type: '@operacaopostocontrolesiad/FIND_POSTOCONTROLESIAD',
    payload: { poco_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaopostocontrolesiad/FAILED_REQUEST',
  };
}

export function deleteOperacaoPostoControleSiad(poco_codigo, params) {
  return {
    type: '@operacaopostocontrolesiad/DELETE_POSTOCONTROLESIAD',
    payload: { poco_codigo, params },
  };
}

export function updateOperacaoPostoControleSiad(operacaopostocontrolesiad, params) {
  return {
    type: '@operacaopostocontrolesiad/UPDATE_POSTOCONTROLESIAD',
    payload: { operacaopostocontrolesiad, params },
  };
}

export function storeOperacaoPostoControleSiad(operacaopostocontrolesiad, params) {
  return {
    type: '@operacaopostocontrolesiad/STORE_POSTOCONTROLESIAD',
    payload: { operacaopostocontrolesiad, params },
  };
}

export function successInRequest(
  operacaopostocontrolesiad,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaopostocontrolesiad/SUCCESS_IN_REQUEST',
    payload: { operacaopostocontrolesiad, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaopostocontrolesiad) {
  return {
    type: '@operacaopostocontrolesiad/SUCCESS_REQUEST',
    payload: { operacaopostocontrolesiad },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaopostocontrolesiad/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaopostocontrolesiad/RECORD_FILTERING',
    payload: { params },
  };
}
